export enum Store {
    APPLE = 'apple',
    GOOGLE = 'google',
    AMAZON = 'amazon',
    TOCA = 'toca',
    XSOLLA = 'xsolla',
}

export enum ApiAvailableStore {
    APPLE = 'apple',
    GOOGLE = 'google',
}

export type StoreUnion = `${Store}`;
